var blogMenuBarCatDropdown = Array(document.querySelectorAll('[data-toggle="cat-dropdown"]'))[0];
if (blogMenuBarCatDropdown) {
	blogMenuBarCatDropdown.forEach(toggle => {
		var container = toggle.closest('.c-blog-menu-bar__main-list-item');
		toggle.addEventListener('click', (e)=>{
			e.preventDefault();
			if (container.classList.contains('open')) {
				container.classList.remove('open')
			}else{
				container.classList.add('open')
			}
		})
		window.addEventListener('click', (e)=>{
			if(!container.contains(e.target)){
				container.classList.remove('open')
			}
		})
	});
}